import { useState } from 'react'
import { DepartmentTreeSelect, PermissionMatrix } from '@/components/permissions'

export default function RolesPage() {
	const [selectedDeptId, setSelectedDeptId] = useState<number | null>(null)
	const [permissionMatrixVersion, setPermissionMatrixVersion] = useState(0)

	return (
		<div className="flex flex-col lg:flex-row gap-6 h-[calc(100vh-120px)]">
			{/* 左侧：部门树 */}
			<div className="w-full lg:w-80 shrink-0 border rounded-lg overflow-auto max-h-[40vh] lg:max-h-full">
				<DepartmentTreeSelect
					selectedId={selectedDeptId}
					onSelect={setSelectedDeptId}
					onPermissionsCopied={(targetIds) => {
						if (selectedDeptId && targetIds.includes(selectedDeptId)) {
							setPermissionMatrixVersion((version) => version + 1)
						}
					}}
				/>
			</div>

			{/* 右侧：权限配置面板 */}
			<div className="flex-1 border rounded-lg p-6 overflow-auto">
				{selectedDeptId ? (
					<div>
						<div className="mb-6">
							<h1 className="text-2xl font-semibold">权限配置</h1>
							<p className="text-muted-foreground mt-1">
								配置该部门的权限，部门内所有用户将继承这些权限
							</p>
						</div>
						<PermissionMatrix
							key={`${selectedDeptId}-${permissionMatrixVersion}`}
							departmentId={selectedDeptId}
						/>
					</div>
				) : (
					<div className="text-muted-foreground flex items-center justify-center h-full">
						<div className="text-center">
							<p className="text-lg">请选择一个部门</p>
							<p className="text-sm mt-1">从左侧选择部门来配置权限</p>
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
